import { META_IMAGES, OG_IMAGES } from '@/v2/constants/images/meta'
import { AUTH_ROUTES, PUBLIC_MAIN_ROUTES } from '@/v2/constants/routes'
import { OGImageType } from '@/v2/types/meta'

export const ogImages: OGImageType[] = [
  {
    url: OG_IMAGES.BASE_URL.concat('/document-storage-services.jpg'),
    alt: 'document storage services page og',
    width: 1200,
    height: 630
  }
]

export const metaImages: OGImageType[] = [
  {
    url: META_IMAGES.DEFAULT,
    alt: 'document storage services page search image',
    width: 92,
    height: 92
  },
  ...ogImages
]

export const heroSectionContent = {
  title: 'Reliable <span>Document</span><span>Storage Services Available</span>',
  description:
    'Safeguard your business’s important records with secure, accessible, and affordable document storage services.',
  image: {
    url: '/images/v2/pages/landing-pages/document-storage-services/hero-image.jpg',
    alt: 'Reliable Document Storage Services Available'
  },
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Sign Up for Document Storage' }
}

export const ourProcessSectionContent = {
  title: 'How Our Document Storage Services Work',
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' },

  image: {
    url: '/images/v2/pages/landing-pages/document-storage-services/how-our-document-storage-services-work.png',
    alt: 'How Our Document Storage Services Work'
  },

  articles: [
    {
      id: 1,
      title: 'Efficient Document Categorization',
      description: 'We organize your documents with a system that makes retrieval easy and fast.',
      image: {
        src: '/images/v2/pages/landing-pages/document-storage-services/01-efficient-document-categorization.svg',
        alt: 'Efficient Document Categorization'
      }
    },
    {
      id: 2,
      title: 'Secure, Monitored Facilities',
      description:
        'Our storage units are equipped with the latest security technology to ensure your files are safe from unauthorized access.',
      image: {
        src: '/images/v2/pages/landing-pages/document-storage-services/02-secure-monitored-facilities.svg',
        alt: 'Secure, Monitored Facilities'
      }
    },
    {
      id: 3,
      title: 'On-Demand Retrieval',
      description:
        'Need documents quickly? Our retrieval services allow you to access your records whenever you need them.',
      image: {
        src: '/images/v2/pages/landing-pages/document-storage-services/03-on-demand-retrieval.svg',
        alt: 'On-Demand Retrieval'
      }
    }
  ]
}

export const reliableShipSectionContent = {
  id: 1,
  title: 'Affordable Document Storage Solutions',
  description:
    'Our services offer secure and organized document storage for businesses, safeguarding your important records and ensuring they remain accessible whenever needed. With our affordable solutions, you can streamline your information management while maintaining peace of mind regarding the protection of your sensitive data.',
  image: {
    src: '/images/v2/pages/landing-pages/document-storage-services/affordable-document-storage-solutions.jpg',
    alt: 'Affordable Document Storage Solutions'
  }
}

export const serviceTipsSectionContent = {
  title: 'Benefits of Using Document Storage Services',

  cards: [
    {
      id: 1,
      title: 'Enhanced Security',
      description:
        'Protect sensitive information with 24/7 surveillance, restricted access, and fire-resistant storage options.',
      image: {
        src: '/images/v2/pages/common/enhanced-security2.png',
        alt: 'Enhanced Security'
      }
    },
    {
      id: 2,
      title: 'Free Up Office Space',
      description: 'Store documents offsite to reclaim valuable office space for your team.',
      image: {
        src: '/images/v2/pages/common/free-up-office-space.png',
        alt: 'Free Up Office Space'
      }
    },
    {
      id: 3,
      title: 'Improved Compliance',
      description:
        'Stay compliant with industry regulations by retaining documents in secure, controlled environments.',
      image: {
        src: '/images/v2/pages/common/improved-compliance.png',
        alt: 'Improved Compliance'
      }
    }
  ]
}

export const helperSectionContent = {
  title: 'Who Should Use Document Storage Services?',

  articles: [
    {
      content: [
        {
          id: 1,
          title: 'Small and Medium Businesses',
          description:
            'Store critical business records securely without the need for large storage spaces in your office.'
        },
        {
          id: 2,
          title: 'Corporations',
          description: 'Maintain compliance and easily access vast amounts of documents stored offsite.'
        },
        {
          id: 3,
          title: 'Healthcare Providers',
          description: 'Safeguard patient records in compliance with healthcare regulations.'
        },
        {
          id: 4,
          title: 'Law Firms',
          description: 'Ensure confidential client files are stored securely and are easy to retrieve when needed.'
        }
      ],
      image: {
        src: '/images/v2/pages/landing-pages/document-storage-services/who-should-use-document-storage-services.jpg',
        alt: 'Who Should Use Document Storage Services?'
      }
    }
  ]
}

export const benefitsSectionContent = {
  title: 'Our Document Storage Services',

  cards: [
    {
      id: 1,
      title: 'Short-Term Document Storage',
      description: 'Perfect for temporary storage during audits, relocations, or document reviews.',
      image: {
        src: '/images/v2/pages/common/short-term-document-storage.png',
        alt: 'Short-Term Document Storage'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    },
    {
      id: 2,
      title: 'Document Shredding Services',
      description:
        "When it's time to dispose of outdated documents, our shredding services ensure safe and secure destruction.",
      image: {
        src: '/images/v2/pages/common/secure-shredding-services.png',
        alt: 'Document Shredding Services'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    },
    {
      id: 3,
      title: 'Long-Term Archival Storage',
      description: 'Store records for extended periods, maintaining compliance with retention policies.',
      image: {
        src: '/images/v2/pages/common/long-term-archival-storage.png',
        alt: 'Long-Term Archival Storage'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    },
    {
      id: 4,
      title: 'Digital Document Conversion',
      description: 'Convert your physical documents to digital formats for easy access and storage.',
      image: {
        src: '/images/v2/pages/common/digital-document-conversion2.png',
        alt: 'Digital Document Conversion'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    }
  ]
}

export const whyChooseSectionContent = {
  title: 'Why Choose Us for Document Storage Services?',

  image: {
    url: '/images/v2/pages/landing-pages/document-storage-services/why-choose-us-for-document-storage-services.jpg',
    alt: 'Why Choose Us for Document Storage Services?'
  },

  articles: [
    {
      id: 1,
      title: '24/7 Security',
      description: 'Your documents are stored in secure facilities with round-the-clock surveillance.'
    },
    {
      id: 2,
      title: 'Cost-Effective Solutions',
      description: 'We offer affordable pricing with no hidden fees, ensuring your business gets the best value.'
    },
    {
      id: 3,
      title: 'Compliance-Focused',
      description: 'We help you stay compliant with industry regulations by offering secure document storage solutions.'
    },
    {
      id: 4,
      title: 'Quick and Easy Access',
      description: 'Retrieve your documents whenever you need them, hassle-free, with our efficient retrieval system.'
    },
    {
      id: 5,
      title: 'Flexible Storage Options',
      description: 'Choose from a variety of storage plans based on your needs—whether short-term or long-term.'
    },
    {
      id: 6,
      title: 'Eco-Friendly Options',
      description:
        'Our digital conversion services help reduce paper waste, contributing to a more sustainable business.'
    }
  ]
}

export const promotionalBannerSectionContent = {
  id: 1,
  title: 'Document Storage Services Available Now',
  description:
    'Document storage services available now. Secure, fast, and affordable options for storing important documents safely.',
  image: {
    src: '/images/v2/pages/landing-pages/document-storage-services/document-storage-services-available-now.png',
    alt: 'Document Storage Services Available Now'
  },
  ctaButton: { href: PUBLIC_MAIN_ROUTES.MOVING_BOX_STORAGE.href, text: 'Start Storing Your Documents' }
}

export const ourPartnersSectionContent = {
  title: 'Our Trusted Storage Partners',
  description: 'We partner with top-tier companies to ensure your documents are securely stored and easily accessible.',

  cards: [
    {
      id: 1,
      title: 'FedEx',
      description: [
        'FedEx offers safe and efficient logistics for document storage and retrieval.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. FedEx does not guarantee the accuracy or completeness of the information provided. For more information, visit <a href='https://www.fedex.com/en-us/home.html' target='_blank'>FedEx.com</a>. FedEx® is a registered trademark. © 1995-2024 FedEx."
      ]
    },
    {
      id: 2,
      title: 'DHL',
      description: [
        'DHL provides secure solutions for the storage and transport of important documents.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. DHL does not guarantee the accuracy of the information provided. For more information, visit <a href='https://www.dhl.com/global-en/home.html' target='_blank'>DHL.com</a>. DHL® is a registered trademark of DHL International GmbH. All rights reserved."
      ]
    },
    {
      id: 3,
      title: 'UPS',
      description: [
        'UPS offers reliable document storage and retrieval services for businesses of all sizes.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. UPS does not guarantee the accuracy or completeness of the information provided. For more information, visit <a href='https://www.ups.com' target='_blank'>UPS.com</a>. UPS® is a registered trademark of UPS Inc. All rights reserved."
      ]
    }
  ]
}
